import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'multiSelection',
    pure: true
})
export class MultiSelectionPipe implements PipeTransform {

    transform(id: number, selectedIds: Set<number>): boolean {
        if (!selectedIds) {
            return false;
        }
        return selectedIds.has(id);
    }
}

